import UserPage from 'src/pages/User';
import DashboardAppPage from 'src/pages/Dashboard';
import { Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from 'src/layouts/dashboard/DashboardLayout';
import BookingPage from 'src/pages/Booking';
import RejectedPage from 'src/pages/Rejected';
import SettingPage from 'src/pages/SettingPage';
import BookingDetailsPage from 'src/pages/BookingDetailsPage';
import DeletedPage from 'src/pages/Deleted';
import DriverPage from 'src/pages/Driver';
export default function HomeRouter() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={`/`} replace />} />
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<DashboardAppPage />} />
        <Route path="/user" element={<UserPage />} />
        <Route path="/driver" element={<DriverPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/rejected" element={<RejectedPage />} />
        <Route path="/setting" element={<SettingPage />} />
        <Route path="/booking-details" element={<BookingDetailsPage />} />
        <Route path="/deleted" element={<DeletedPage />} />
      </Route>
    </Routes>
  );
}
